import { impressionTaxesAndChargesLineItem } from "@cart-client/analytics/events";
import { getCartId } from "@cart-client/helpers/Cart";
import { ReviewedCart } from "@cart-client/interfaces/Cart";
import { AnalyticsContext } from "@swiggy-private/checkout-core";
import { isEmpty } from "@swiggy-private/js-utils";
import { useCallback, useContext } from "react";

export function useBillDetailsAnalytics(cartResponse: ReviewedCart | null) {
    const { impressionEvent } = useContext(AnalyticsContext);
    const onImpressionTaxesAndChargesLineItem = useCallback(
        (context: string): void => {
            if (!isEmpty(cartResponse) && cartResponse) {
                impressionTaxesAndChargesLineItem(impressionEvent, context, getCartId(cartResponse));
            }
        },
        [cartResponse, impressionEvent],
    );

    return {
        onImpressionTaxesAndChargesLineItem,
    };
}
